import { produce } from "immer";
import { createSelector } from "reselect";
import * as Types from "./constants";

export const initialState = {
  currentUser: {
    token: localStorage.getItem("aghighToken"),
    name: "",
    slug: "",
    photo: "",
    gender: "",
    isAdviser: false,
    userId: "",
    hasGenderLimit: false,
    canRegisterActivity: false,
    mark: [],
    roles: [],
    categoryList: [],
    subjectList: [],
    menu: [],
    roundList: [],
    notifications: [],
  },
  tour: { tourActive: false, run: false, stepIndex: 0 },
  loadingBoomPage: false,
  loadingSearchingPage: false,
  loadingMyActivityPage: false,
  searchLoading: false,
  searchHistoryResultList: [],
  activityList: [],
  activityListTab1: [],
  activityListTab2: [],
  activityListTab3: [],
  activityListTab4: [],
  searchActivityQuery: "",
  extraBoom: [],
  extraSearch: [],
  boomPage: 1,
  extraBoomPage: 1,
  searchingPage: 1,
  extraSearchingPage: 1,
  myActivityPage: 1,
  followPage: 1,
  hasMore1: true,
  extraHasMore1: true,
  hasMore2: true,
  extraHasMore2: true,
  hasMore3: true,
  hasMore4: true,
  myActivityFilter: "all",
  scrollToBoom: 0,
  scrollToSearch: 0,
  scrollToMyActivity: 0,
  searchFilterDrawerOpen: false,
  searchFilterDrawerOpenMobile: false,
  myActivityFilterDrawerOpenMobile: false,
  messagingOpenMobileBlur: 0,
  profileModal: false,
  drawer: false,
  isLogin:
    localStorage.getItem("aghighToken") &&
    localStorage.getItem("aghighToken")?.length > 5
      ? true
      : false,
  step: 1,
  exitLoading: false,
  //home
  topSlider: [],
  kpi: [],
  mostPopularSlider: [],
  medals: [],
  isLoading: false,
  //school
  schoolActivities: [],
  schoolActivitiesPage: 1,
  schoolHasMore: true,
};
const selectActivityDomain = (state) => state.main || initialState;

/* eslint-disable default-case, no-param-reassign */
const mainReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Types.CHANGE_THEME:
        draft.themeMode = action.payload;
        break;
      case Types.SET_TOUR:
        draft.tour = action.payload;
        break;
      case Types.CLOSE_PROFILE:
        draft.profileModal = false;
        break;
      case Types.TOGGLE_PROFILE:
        draft.profileModal = !state.profileModal;
        break;
      case Types.CLOSE_DRAWER:
        draft.drawer = action.payload;
        break;
      case Types.TOGGLE_DRAWER:
        draft.drawer = !state.drawer;
        break;
      case Types.LOG_OUT_REQUESTED:
        draft.exitLoading = true;
        break;
      case Types.LOG_OUT_SUCCESS:
        draft.currentUser.token = "";
        draft.exitLoading = false;
        draft.isLogin = false;
        draft.activityList = [];
        draft.activityListTab1 = [];
        draft.activityListTab2 = [];
        draft.activityListTab3 = [];
        draft.activityListTab4 = [];
        draft.boomPage = 1;
        draft.searchingPage = 1;
        draft.myActivityPage = 1;
        draft.followPage = 1;
        draft.hasMore1 = true;
        draft.hasMore2 = true;
        draft.hasMore3 = true;
        draft.hasMore4 = true;
        break;
      case Types.LOG_OUT_FAILED:
        draft.exitLoading = false;
        break;
      case Types.FORGET_PASSWORD_STEP:
        draft.step = action.payload;
        break;
      case Types.SIGN_IN_REQUESTED:
        break;
      case Types.SIGN_IN_SUCCESS:
        draft.isLogin = true;
        draft.currentUser.token = action.payload;

        break;
      case Types.SIGN_IN_FAILED:
        break;
      case Types.GET_PROFILE_REQUESTED:
        break;
      case Types.GET_PROFILE_SUCCESS:
        draft.currentUser.name = action.payload.user.full_name;
        draft.currentUser.slug = action.payload.user.slug;
        draft.currentUser.photo = action.payload.user.photo_url;
        draft.currentUser.gender = action.payload.user.gender;
        draft.currentUser.hasGenderLimit = action.payload.user.gender_limit;
        draft.currentUser.hasProvinceLimit = action.payload.user.province_limit;
        draft.currentUser.canRegisterActivity =
          action.payload.user.can_register_Activity;
        draft.currentUser.mark = action.payload.user.mark;
        draft.currentUser.roles = action.payload.user.roles;
        draft.currentUser.categoryList = action.payload.user.category_list;
        draft.currentUser.subjectList = action.payload.user.subject_list;
        draft.currentUser.menu = action.payload.user.menu;
        draft.currentUser.roundList = action.payload.user.round_list;
        draft.currentUser.notifications = action.payload.user.notifications;
        draft.currentUser.menu = action.payload.user.menu;
        draft.currentUser.isAdviser = action.payload.user.is_adviser;
        draft.currentUser.userId = action.payload.user.id;
        draft.currentUser.temp = action.payload.user.temp;
        break;

      case Types.GET_PROFILE_FAILED:
        break;

      case Types.GET_SEARCH_HISTORY_RESULT_REQUESTED:
        draft.searchLoading = true;
        break;

      case Types.GET_SEARCH_HISTORY_RESULT_SUCCESS:
        draft.searchLoading = false;
        draft.searchHistoryResultList = action.payload;
        break;
      case Types.GET_SEARCH_HISTORY_RESULT_FAILED:
        draft.searchLoading = false;
        break;

      case Types.SET_NOTIFICATIONS_SEEN_REQUESTED:
        break;
      case Types.SET_NOTIFICATIONS_SEEN_SUCCESS:
        if (action?.payload?.notificationId === "all") {
          draft.currentUser.notifications = [];
        } else {
          draft.currentUser.notifications =
            state.currentUser.notifications?.filter(
              (item) => item.id !== action.payload.notificationId
            );
        }
        break;
      case Types.SET_NOTIFICATIONS_SEEN_FAILED:
        break;
      case Types.GET_MY_BOOM_REQUESTED:
        draft.loadingBoomPage = true;
        break;
      case Types.GET_MY_BOOM_SUCCESS:
        if (action.payload?.length) {
          const Array = [...state.activityListTab1, ...action.payload];
          const newArray = Array.filter(
            (v, i, a) => a.findIndex((t) => t.slug === v.slug) === i
          );
          draft.activityListTab1 = [...newArray];
          draft.boomPage = state.boomPage + 1;
        } else {
          draft.hasMore1 = false;
        }
        draft.loadingBoomPage = false;
        break;
      case Types.GET_MY_BOOM_FAILED:
        draft.loadingBoomPage = false;
        break;
      case Types.GET_EXTRA_MY_BOOM_REQUESTED:
        draft.loadingBoomPage = true;
        break;
      case Types.GET_EXTRA_MY_BOOM_SUCCESS:
        if (action.payload?.length) {
          draft.extraBoom = action.payload;
          draft.extraBoomPage = state.extraBoomPage + 1;
        } else {
          draft.extraHasMore1 = false;
        }
        draft.loadingBoomPage = false;
        break;
      case Types.GET_EXTRA_MY_BOOM_FAILED:
        draft.loadingBoomPage = false;
        break;
      case Types.GET_ACTIVITY_SEARCH_REQUESTED:
        draft.loadingSearchingPage = true;
        break;
      case Types.GET_ACTIVITY_SEARCH_SUCCESS:
        if (action.payload?.length > 0) {
          const Array = [...state.activityListTab2, ...action.payload];
          const newArray = Array.filter(
            (v, i, a) => a.findIndex((t) => t.slug === v.slug) === i
          );
          draft.activityListTab2 = [...newArray];
          draft.searchingPage = state.searchingPage + 1;
          draft.extraSearchingPage = state.extraSearchingPage + 1;
        } else {
          draft.hasMore2 = false;
        }
        draft.loadingSearchingPage = false;

        break;
      case Types.GET_ACTIVITY_SEARCH_FAILED:
        draft.loadingSearchingPage = false;
        break;
      case Types.SET_SEARCH_ACTIVITY_QUERY:
        draft.searchActivityQuery = action?.payload;
        break;
      case Types.GET_EXTRA_ACTIVITY_SEARCH_REQUESTED:
        draft.loadingSearchingPage = true;
        break;
      case Types.GET_EXTRA_ACTIVITY_SEARCH_SUCCESS:
        if (action.payload?.length > 0) {
          draft.extraSearch = [...state.extraSearch, ...action.payload];
          draft.extraSearchingPage = state.extraSearchingPage + 1;
        } else {
          draft.extraHasMore2 = false;
        }
        draft.loadingSearchingPage = false;

        break;
      case Types.GET_EXTRA_ACTIVITY_SEARCH_FAILED:
        draft.loadingSearchingPage = false;
        break;
      case Types.GET_MY_ACTIVITY_REQUESTED:
        draft.loadingMyActivityPage = true;
        break;
      case Types.GET_MY_ACTIVITY_SUCCESS:
        draft.loadingMyActivityPage = false;
        if (action.payload?.length) {
          const Array = [...action.payload];
          draft.activityListTab3 = [...Array];
          draft.myActivityPage = state.myActivityPage + 1;
        } else {
          draft.hasMore3 = false;
        }
        break;
      case Types.GET_MY_ACTIVITY_FAILED:
        draft.loadingMyActivityPage = false;
        break;
      case Types.GET_MY_FOLLOWING_REQUESTED:
        draft.loadingBoomPage = true;
        break;
      case Types.GET_MY_FOLLOWING_SUCCESS:
        if (action.payload?.length) {
          draft.activityList = [...action.payload];
        } else {
          draft.hasMore4 = false;
        }
        break;
      case Types.GET_MY_FOLLOWING_FAILED:
        break;
      case Types.SET_ALL_TAB_PAGE_ONE:
        draft.boomPage = 1;
        draft.searchingPage = 1;
        break;
      case Types.SET_RESET_TAB_2:
        draft.searchingPage = 1;
        draft.activityListTab2 = [];
        break;
      case Types.SET_MY_ACTIVITY_FILTER:
        draft.myActivityFilter = action.payload;
        break;
      case Types.SET_MY_ACTIVITY_LIST:
        draft.activityListTab3 = action.payload;
        break;
      case Types.REMOVE_MY_ACTIVITY:
        draft.activityListTab3 = state.activityListTab3.filter(
          (el) => el.slug !== action.payload
        );
        break;
      case Types.SET_SCROLL_TO_BOOM:
        draft.scrollToBoom = action.payload;
        break;
      case Types.SET_SCROLL_TO_SEARCH:
        draft.scrollToSearch = action.payload;
        break;
      case Types.SET_SCROLL_TO_MY_ACTIVITY:
        draft.scrollToMyActivity = action.payload;
        break;
      case Types.SET_SEARCH_FILTER_DRAWER_OPEN:
        draft.searchFilterDrawerOpen = action.payload;
        break;
      case Types.SET_SEARCH_FILTER_DRAWER_OPEN_MOBILE:
        draft.searchFilterDrawerOpenMobile = action.payload;
        break;
      case Types.SET_MY_ACTIVITY_FILTER_DRAWER_OPEN_MOBILE:
        draft.myActivityFilterDrawerOpenMobile = action.payload;
        break;
      case Types.SET_MESSAGING_OPEN_MOBILE_BLUR:
        draft.messagingOpenMobileBlur = action.payload;
        break;
      //home page
      case Types.HOME_DATA_REQUESTED:
        draft.isLoading = true;
        break;
      case Types.HOME_DATA_SUCCESS:
        draft.kpi = action.payload.kpi;
        draft.medals = action.payload.medals;
        draft.mostPopularSlider = action.payload.most_popular;
        draft.topSlider = action.payload.slider;
        draft.isLoading = false;
        break;
      case Types.HOME_DATA_FAILED:
        draft.isLoading = false;
        break;
      //school
      case Types.SCHOOL_DATA_REQUESTED:
        break;
      case Types.SCHOOL_DATA_SUCCESS:
        const Array = [...state.schoolActivities, ...action.payload];
        draft.schoolActivities = Array.filter(
          (v, i, a) => a.findIndex((t) => t.slug === v.slug) === i
        );
        draft.schoolActivitiesPage = state.schoolActivitiesPage + 1;
        if (action.payload?.length === 0) {
          draft.schoolHasMore = false;
        }
        break;
      case Types.SET_TRUE_FOR_HAS_MORE_2:
        draft.hasMore2 = true;
        break;
      case Types.SCHOOL_DATA_FAILED:
        break;
      default:
        return state;
    }
  });

export default mainReducer;
export const makeSelectActivity = () =>
  createSelector(selectActivityDomain, (substate) => substate);
